import React, { useContext, useState } from 'react';
import * as R from 'ramda';
import { func } from 'prop-types';

// Components
import { Box, ButtonBase, Typography } from '@mui/material';
import ExplicitConfirmationDialog from 'common/dialog-explicit-confirmation/DialogExplicitConfirmation';
import Buttons from '../../components/Buttons';
import SummaryDrawer from '../../components/SummaryDrawer';

// Context
import { SequencingWizardContext } from '../../SequencingWizardContext';

const SequenceStep4 = ({ next, prev }) => {
  const {
    data: { action },
    setData,
  } = useContext(SequencingWizardContext);
  const [dialogOpen, setDialogOpen] = useState(false);

  const renderActionButton = (actionText, value) => (
    <ButtonBase
      onClick={() => {
        setData(
          R.evolve({
            action: R.always(value),
            applyOnFutureDate: R.always(null),
            futureDate: R.always(undefined),
          })
        );
      }}
      sx={{
        alignItems: 'center',
        backgroundColor: action === value ? 'secondary.light' : 'transparent',
        border: '2px solid',
        borderColor: action === value ? 'transparent' : 'primary.main',
        borderRadius: 0.5,
        display: 'flex',
        justifyContent: 'center',
        mt: 2,
        p: 3,
        textAlign: 'left',
      }}
    >
      <Typography color="textPrimary" variant="body1">
        {actionText}
      </Typography>
    </ButtonBase>
  );

  const replaceText = 'Replace the entire sequence for each location and product';
  const insertText = 'Insert at the beginning of the sequence for each location and product';

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          // height of other components is 157px
          // prevents progress bar from looking off
          height: 'calc(100% - 157px)',
          // Prevents bottom selection from clipping on Y overflow
          marginBottom: 46,
          overflowY: 'auto',
        }}
      >
        <Box mb={0} mt={3} mx={3} pb={6}>
          <Typography color="textPrimary" variant="body1">
            How would you like to apply the sequence?
          </Typography>
          {renderActionButton(replaceText, 'Replace')}
          {renderActionButton(insertText, 'Prepend')}
        </Box>
        <SummaryDrawer displayProductLocations inventoryOwnerSubtitle="Selected Inventory Owner" />
      </Box>
      <Buttons
        disabled={!action}
        handleLeftButtonClick={prev}
        handleRightButtonClick={action === 'Replace' ? () => setDialogOpen(true) : next}
        leftLabel="Back"
        loadingData={false}
        rightLabel="Continue"
      />
      {dialogOpen && (
        <ExplicitConfirmationDialog
          confirmationMessage="If you still want to replace the entire sequence, enter the word below and click Confirm."
          confirmationValue="REPLACE"
          dialogOpen={dialogOpen}
          handleCloseDialog={() => setDialogOpen(false)}
          label="Replace"
          onConfirm={next}
          title="Replace Sequence?"
          warningList={['This will Replace the entire sequence for each location and product.']}
        />
      )}
    </>
  );
};

SequenceStep4.propTypes = {
  next: func.isRequired,
  prev: func.isRequired,
};

export default SequenceStep4;
